import Vue from 'vue'
import Vuex from 'vuex'
import auth from './modules/auth'
import state from './state'
import mutations from './mutations'
import actions from './actions'
import getters from './getters'

Vue.use(Vuex)

const debug = process.env.NODE_ENV !== 'production'

const store = new Vuex.Store({
  modules: {
    auth
  },
  state: state,
  mutations: mutations,
  actions: actions,
  getters: getters,
  strict: debug
})

export default store
